module.exports = {
    fulfilmentTimetable: {
        noAvailableTimesMessage:
            'Unfortunately we do not deliver to this area yet. Please try another address or change your delivery to pick up.',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/fulfilment-timetable.js